import bootstrap from "shared/bootstrap";
import baseManifest from "modules/base";
import portalManifest from "./portal-manifest";
import envLoader from "shared/env-loader";
import relationprofile from "modules/relationprofile";
import appointments from "modules/appointments";
import projects from "modules/projects";
import manuals from "modules/manuals";
import feedback from "modules/feedback";
import invoices from "modules/invoices";
import contact from "modules/contact";
import customLocalisation from "./i18n";

const vuetify = {
  theme: {
    primary: "#3f3e3a",
    secondary: "#6a715e",
    accent: "#bad1e2",
    error: "#f44336",
    warning: "#ffeb3b",
    info: "#2196f3",
    success: "#6a715e",
  },
};

bootstrap({
  title: "Uw klantportaal van Paul Hoevenaars Designtuinen",
  vuetify,
  customLocalisation,
  modules: [
    baseManifest,
    portalManifest,
    relationprofile,
    appointments,
    projects,
    invoices,
    manuals,
    feedback,
    contact,
  ],
  axios: {
    baseURL: envLoader("API_URL", "/"),
    withCredentials: true,
  },
  loginBackground: "/images/wallpaper.jpg",
  customToolbar: [
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    () => import("../../modules/feedback/components/ToolbarFeedbackAction.vue"),
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    () => import("../../modules/contact/components/GlobalContactButton.vue"),
  ],
});
